import { render, staticRenderFns } from "./PointStatusComponent.vue?vue&type=template&id=01c8fcdd&scoped=true"
import script from "./PointStatusComponent.vue?vue&type=script&lang=js"
export * from "./PointStatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c8fcdd",
  null
  
)

export default component.exports